import { FormattedDate } from 'react-intl';

interface DateFormatterProps {
  date: Date | string;
}

function DateFormatter({ date }: DateFormatterProps) {
  const dateObject = typeof date === 'string' ? new Date(date) : date;

  return (
    <div>
      <FormattedDate weekday="long" value={new Date(dateObject)} />,{' '}
      <FormattedDate day="numeric" value={new Date(dateObject)} />{' '}
      <FormattedDate month="long" value={new Date(dateObject)} />
    </div>
  );
}

export default DateFormatter;
